module.exports = __webpack_public_path__ + "img/money9.bb881c69.png";